import { ShieldCheck, MapPin } from "lucide-react";

const approvedVolunteers = [
  {
    id: 1,
    name: "Bilal Ahmed",
    area: "Hyderabad",
    approvedOn: "05 Jan 2026",
    status: "Active",
  },
  {
    id: 2,
    name: "Fatima Zahra",
    area: "Pune",
    approvedOn: "02 Jan 2026",
    status: "Active",
  },
];

const VolunteerApproved = () => {
  // const [pendingVolunteers, setPendingVolunteers] = useState([]);
  // const [pagination, setpagination] = useState({
  //   current_page: 1,
  //   per_page: 10,
  // });
  // const [loading, setLoading] = useState(false);

  // useEffect(() => {
  //   fetchvolunteer();
  // }, []);

  // const fetchvolunteer = async () => {
  //   try {
  //     const res = await pendingvol({ page: pagination.current_page });
  //     console.log(res);

  //     setPendingVolunteers(res.data);
  //     setpagination(res.pagination_info);
  //   } catch (err) {
  //     console.error("Error fetching causes:", err);
  //   } finally {
  //   }
  // };

  return (
    <div className="allcause-page">
      <header className="page-header">
        <h2>Approved Volunteers</h2>
        <p>Trusted volunteers allowed to verify causes</p>
      </header>

      <div className="allcause-card">
        <table className="allcause-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Region</th>
              <th>Approved On</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {approvedVolunteers.map((vol) => (
              <tr key={vol.id}>
                <td>
                  <ShieldCheck size={16} /> {vol.name}
                </td>
                <td>
                  <MapPin size={14} /> {vol.area}
                </td>
                <td>{vol.approvedOn}</td>
                <td>
                  <span className="badge success">{vol.status}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default VolunteerApproved;
